import { render } from "./KSFromGroupReport.vue?vue&type=template&id=76380b1e"
import script from "./KSFromGroupReport.vue?vue&type=script&lang=js"
export * from "./KSFromGroupReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__